/**
 * Maps old saved data format to the new field structure.
 * @param {object} data
 * @returns {object}
 */
export function migrateFormValues(data) {
  const oldIntervals = ["days", "months", "day", "dayOfMonth"];

  if (!oldIntervals.includes(data?.interval)) {
    return normalizeWeekday(data);
  }

  const intervalMap = {
    days: "daily",
    day: "weekly",
    months: "monthly",
    dayOfMonth: "monthly"
  };

  const [hours, minutes] = (data.time || "00:00:00").split(":");

  const migrated = { ...data };
  migrated.interval = intervalMap[data.interval];
  migrated.dayOfMonth =
    data.dayAmount ?? (intervalMap[data.interval] === "monthly" ? 1 : null);
  migrated.startHour = parseInt(hours, 10);
  migrated.minuteOfHour = parseInt(minutes, 10);

  delete migrated.amount;
  delete migrated.dayAmount;
  delete migrated.time;

  return normalizeWeekday(migrated);
}

/**
 * Ensures weekday is always an array for the buttonGroup.
 * @param {object} data
 * @returns {object}
 */
function normalizeWeekday(data) {
  if (data?.weekday === null || data?.weekday === undefined) {
    return data;
  }

  const weekday = Array.isArray(data.weekday) ? data.weekday : [data.weekday];

  return { ...data, weekday: weekday.map(Number) };
}

/**
 * @param {object} config
 * @returns {string}
 */
export function objectToCron(config) {
  const { interval, dayOfMonth, weekday, startHour, minuteOfHour } = config;

  const minute = minuteOfHour ?? 0;
  const hour = startHour ?? 0;

  const intervalMap = {
    daily: [minute, hour, "*", "*", "*"],
    weekly: [
      minute,
      hour,
      "*",
      "*",
      Array.isArray(weekday) && weekday.length ? weekday.join(",") : "*"
    ],
    monthly: [minute, hour, dayOfMonth ?? 1, "*", "*"]
  };

  return (intervalMap[interval] || [minute, hour, "*", "*", "*"]).join(" ");
}
